export type BookingRouteContext = {
    organisationId: string
    businessId: string
    venueId: string
}

export type LandingPageLaunchParams = {
    partySize?: number
    date?: Date
    idealTime?: Date
    startSeconds?: number
    restrictedReasonIds?: string[]
    eventId?: string
    voucherId?: string
    areaId?: string
    autoOpen?: boolean
    rwgToken?: string
    availabilityTag?: string
    utmSource?: string
    utmMedium?: string
    utmCampaign?: string
    requiresWheelchairAccess?: boolean
    requiresDogFriendly?: boolean
    requiresPramAccessible?: boolean
    requiresHighchairFriendly?: boolean
    setupBookingRequestId?: string
    setupCancelled?: boolean
    paymentIntentId?: string
    setupIntentId?: string
}

export type BookingLaunchContext = BookingRouteContext & {
    partySize?: number
    date?: Date
    idealTime?: Date
    restrictedReasonIds?: string[]
    eventId?: string
    areaId?: string
    utmSource?: string
    utmMedium?: string
    utmCampaign?: string
}

export type VoucherLaunchContext = BookingRouteContext & {
    voucherId: string
}

export enum BookingModalPresentationMode {
    LegacyIframe = 'legacy-iframe',
    NgbModal = 'ngb-modal',
}
